import SiteWrapper from "src/components/SiteWrapper";
import ScreenProvider from "src/contexts/ScreenContext";

const AuthLayout = () => {
    return (
        <ScreenProvider>
            <SiteWrapper />
        </ScreenProvider>
    );
}

export default AuthLayout;